export default "__VITE_ASSET__BMdal4qn__"